import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";

interface UseMetricsPermissions {
  canSeeActivity: boolean; // Permiso para ver el bloque de actividad
  canSeeMetricsRow: boolean; // Permiso para ver la fila de métricas (procesos, flujos, procedimientos)
  canSeeFRRow: boolean; // Permiso para ver la fila de FR (resueltos, pendientes, en progreso)
  hasActivityBlock: boolean; // Indica si el usuario tiene permiso para ver el bloque de actividad y al menos una de las filas (arriba de la tabla)

  hasProcedures: boolean;
  hasFlows: boolean;
  hasSolved: boolean;
  hasPending: boolean;
  hasInProgress: boolean;
  hasProcesses: boolean;
}

export const useMetricsPermissions = (): UseMetricsPermissions => {
  const { hasPermission } = useAuthorization();
  const canSeeActivity = hasPermission(Permissions.widgets.activity);
  const hasProcesses = hasPermission(Permissions.widgets.processes);
  const hasFlows = hasPermission(Permissions.widgets.flows);
  const hasSolved = hasPermission(Permissions.widgets.solved);
  const hasPending = hasPermission(Permissions.widgets.pending);
  const hasProcedures = hasPermission(Permissions.widgets.procedures);
  const hasInProgress = hasPermission(Permissions.widgets["in-progress"]);

  const canSeeMetricsRow = hasProcesses || hasFlows || hasProcedures;
  const canSeeFRRow = hasSolved || hasPending || hasInProgress;

  return {
    hasFlows,
    hasProcedures,
    hasSolved,
    hasPending,
    hasInProgress,
    hasProcesses,
    canSeeActivity,
    canSeeMetricsRow,
    canSeeFRRow,
    hasActivityBlock: canSeeActivity && (canSeeMetricsRow || canSeeFRRow),
  };
};
